require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-business-business-products-and-services.json") })
        }
      }, "path---es-business-business-products-and-services");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-business-business-products-and-services!./.cache/json/es-business-business-products-and-services.json
// module id = 2496
// module chunks = 231608221292675